import { Icons, LinkBehaviour } from '@cast/design-system';

type Props = {
  testId?: string;
  title: string;
  isExpanded: boolean;
  onToggle: () => void;
};

export const ToggleButton = ({
  title,
  isExpanded,
  onToggle,
  testId,
}: Props) => {
  const Icon = isExpanded ? Icons.CaretUp : Icons.CaretDown;
  return (
    <LinkBehaviour
      variant="P12M"
      display="flex"
      alignItems="center"
      gap={4}
      onClick={onToggle}
      testId={testId}
    >
      {title}
      <Icon size={16} />
    </LinkBehaviour>
  );
};
